import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=0e7ac1ed&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=ts&"
export * from "./OrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=0e7ac1ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ac1ed",
  null
  
)

export default component.exports